/**
 * One drawn icon from the shared set (`ui.icon.*`, docs/ICON_MAP.md).
 *
 * It exists because the alternative was a system emoji: the viewer's own font, a different picture on iOS, Android and
 * desktop, and in headless Chrome a grey broken glyph where the chilli should be. An icon that changes with the
 * reader's platform is the one thing a drawn art direction cannot survive.
 *
 * It renders in normal flow — a row icon sits in its flex line, so this is a sized element with the art as its
 * background, not a positioned <Art>. If the set does not yet carry an id it renders the emoji it replaces rather than
 * a hole, so the swap can happen file by file and no screen is ever worse than it was mid-swap.
 */
import { artUrl } from '../art-layers';

export function Icon({ id, size = 60, fallback, class: cls = '' }: { id: string; size?: number; fallback?: string; class?: string }) {
  const url = artUrl(`ui.icon.${id}`);
  if (!url) return fallback ? <span class={cls} aria-hidden="true">{fallback}</span> : null;
  return <span class={`icon ${cls}`} aria-hidden="true" style={{ width: size, height: size, backgroundImage: `url(${url})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', flex: 'none' }} />;
}
